import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../shared/utility';
import ConsoleLog from './../../hoc/ConsoleLog/ConsoleLog';
//import { setCandidateCardProfileImage } from '../actions';

/**
* @desc reducer for talent pool
* @version
* @author Lakshmikanth 
* @return updated state
*/
const initialState = {
  pool: [],      
  activeCandidateId: "",
  jobTitleId: null,
  jobTitle:"",
  permittedcontactdata: {},
  jobList: [],
  completed: 0,
  started: 0,
  not_started: 0,
  jobTitleBHID: null,
  companyType: "" ,
  showProgressNotification: false,
};

const setTalentPool = ( state = initialState , action ) => {
  const pool = [...action.talentPool];
  let permittedcontactdata = {...action.talentPool.permittedcontactdata};
  let activeCandidateId = ((pool.length > 0 && pool[0].candidate_id ) ? pool[0].candidate_id : "");
  let completed = 0, started = 0, not_started = 0;

  if(action.isClient && state.activeCandidateId !== "") {
    activeCandidateId = state.activeCandidateId;
  }

  if(action.isClient && pool[0].message) {
    activeCandidateId = "";
  }   

  if(!action.isClient && pool.filter(candidate => candidate.published === 0).length > 0) {
    activeCandidateId = pool.filter(candidate => candidate.published === 0)[0].candidate_id;
  }

  if(!action.isClient && pool[0]) {
    completed = pool[0].completed;
    started = pool[0].started;
    not_started = pool[0].not_started;
  }

  if(permittedcontactdata.permitted_contact_email === null) {
    permittedcontactdata = {};
  }

  return updateObject( state, 
    { pool : pool, 
      activeCandidateId: activeCandidateId, 
      permittedcontactdata: permittedcontactdata,
      completed: completed,
      started: started,
      not_started: not_started
    } );   
};

const selectedCandidate = ( state = initialState , action ) => {
  return updateObject( state, { activeCandidateId : action.candidateId } );
};

const updateCandidateStatus = (state = initialState , action) => {
  const pool = [...state.pool];
  if(pool.length > 0) {
    const currentCandidate = {...pool.find(cand => cand.candidate_id === action.candidateId)};
    const currentCandIndex = pool.findIndex(cand => cand.candidate_id === action.candidateId);

    currentCandidate.candidate_status = action.status;
    if(action.status === "PROGRESS" && action.score) {
      currentCandidate.candidate_scoring = action.score;
      currentCandidate.candidate_score = action.totalScore;
    }

    pool[currentCandIndex] = currentCandidate;
    
    return updateObject( state, { pool : pool } );
  } else {
    return state;
  }      
};

const setJobList = ( state = initialState , action ) => {  
  const jobList = [...action.jobList];
  const job = (localStorage.getItem('jobTitleId') && localStorage.getItem('jobTitleId')!== "" && localStorage.getItem('jobTitleId')!== null && localStorage.getItem('jobTitleId')!== "null") ? jobList.filter((jobtitle) => jobtitle.job_id == localStorage.getItem('jobTitleId'))[0] : jobList[0];
  const jobTitleId = job.job_id;
  const jobTitle = job.job_name;
  const jobTitleBHID = job.job_bh_id;
  const companyType = job.company_type;
  return updateObject( state, { jobList: jobList, jobTitleId: jobTitleId,jobTitle: jobTitle, jobTitleBHID: jobTitleBHID, companyType: companyType } );   
};

const setJobTitle = ( state = initialState , action ) => {
  localStorage.removeItem('jobTitleId');
  return updateObject( state, { jobTitleId: action.jobTitleId,jobTitle: action.jobTitle, jobTitleBHID: action.jobBHID, companyType: action.companyType } );   
};

const updateCurrentRole = (state = initialState , action) => {
  const pool = [...state.pool];
  if(pool.length > 0) {
    const currentCandidate = {...pool.find(cand => cand.candidate_id === action.candidateId)};
    const currentCandIndex = pool.findIndex(cand => cand.candidate_id === action.candidateId);

    currentCandidate.current_job_title = action.currentJobTitle;
    currentCandidate.current_employer = action.currentEmployer;
    pool[currentCandIndex] = currentCandidate;
    
    return updateObject( state, { pool : pool, activeCandidateId : action.candidateId } );
  } else {
    return state;
  }      
};

const clearReduxState = ( state = initialState , action ) => {
  return updateObject( state, initialState );   
};

const clearTalentPool = ( state = initialState , action ) => {
  return updateObject( state, initialState );   
};

const importCandidate = ( state = initialState , action ) => {
  let pool = [...state.pool];
  if(pool.length > 0 && pool[0].message) {
    pool.splice(0,1); 
  }
  let candidate = {...action.candidate};
  pool =  pool.concat(candidate);
  return updateObject( state, { pool : pool } );   
};

const removeCandidate = ( state = initialState , action ) => {
  let pool = [...state.pool];

  const currentCandidate = {...pool[action.candidateIndex]};
  const currentEditStatus = currentCandidate.candidate_edit_status?currentCandidate.candidate_edit_status.toLowerCase().replace(" ", "_"):"";

  pool.splice(action.candidateIndex,1); 

  if(pool.length === 0) {
    pool =  pool.concat({message: 'no data'});
  }

  return updateObject( state, { pool : pool, [currentEditStatus]: state[currentEditStatus]-1, } );   
};

const setPermittedcontactdata = (state = initialState, action) => {
  let permittedcontactdata = {...action.permittedContact};
  
  if(permittedcontactdata.permitted_contact_email === null) {
    permittedcontactdata = {};
  }

  return updateObject( state, { permittedcontactdata : permittedcontactdata } );  
}

const updateCandidateEditStatus = (state = initialState , action) => {
  ConsoleLog("reducer update status pool",state.pool);
  const pool = [...state.pool];
  if(pool.length > 0) {
    const currentCandidate = {...pool.find(cand => cand.candidate_id === action.candidateId)};
    const currentCandIndex = pool.findIndex(cand => cand.candidate_id === action.candidateId);

    const currentEditStatus = currentCandidate.candidate_edit_status.toLowerCase().replace(" ", "_");
    const newEditStatus = action.editStatus.toLowerCase().replace(" ", "_");
    
    currentCandidate.candidate_edit_status = action.editStatus;
    pool[currentCandIndex] = currentCandidate;
    ConsoleLog("reducer update status pool",pool);
    
    return updateObject( state, { pool : pool,
        [currentEditStatus]: state[currentEditStatus]-1,
        [newEditStatus]: state[newEditStatus]+1,
      } );
  }
   else {
    return state;
  }      
};

const updateCandidatePublished = (state = initialState, action) => {
  let pool = [...state.pool];
  pool.filter(candidate => candidate.published === 0).map(candidate => candidate.published = 1);
  return updateObject( state, { pool: pool } );  
};

const setCandidateCardProfileImage = (state =initialState, action) => {
  let pool = [...state.pool];
  const currentCandidate = {...pool.find(cand => cand.candidate_id === action.candidateId)};
  const currentCandIndex = pool.findIndex(cand => cand.candidate_id === action.candidateId);
  currentCandidate.s3SignedUrl = action.s3SignedUrl;
  currentCandidate.candidate_image = action.candidateImage;
  pool[currentCandIndex] = currentCandidate;
  return updateObject( state, { pool: pool } ); 
};
const updateCandidateProfileEdit = (state =initialState, action) => {
  ConsoleLog("reducer edit profile",state.pool);
  let pool = [...state.pool];
  const currentCandidate = {...pool.find(cand => cand.candidate_id === action.candidateId)};
  const currentCandIndex = pool.findIndex(cand => cand.candidate_id === action.candidateId);
  const nameArr = action.candidateName.split(" ");
  const candidateFname = nameArr.splice(0,1).join();
  const candidateLname = nameArr.join(" ");
  currentCandidate.candidate_name = action.candidateName;
  currentCandidate.candidate_fname =candidateFname;
  currentCandidate.candidate_lname =candidateLname;
  currentCandidate.initials =action.candidateInitials;
  currentCandidate.candidate_email = action.candidateEmail;
  pool[currentCandIndex] = currentCandidate;
  ConsoleLog("reducer pool edit profile",pool);
  return updateObject( state, { pool: pool, activeCandidateId : action.candidateId } ); 
  
}

const setProgressNotification = (state = initialState, action) => {
  return updateObject( state, { showProgressNotification: action.showProgressNotification } ); 
}

const setInterviewExists = (state = initialState, action) => {
  return updateObject( state, { InterviewExists: action.InterviewExists } ); 
}

const reducer = ( state = initialState, action ) => {
  switch ( action.type ) {
    case actionTypes.SET_TALENTPOOL: 
      return setTalentPool(state, action);
    case actionTypes.SET_CANDIDATE_STATUS:
      return updateCandidateStatus(state,action); 
    case actionTypes.VIEW_CANDIDATE:
      return selectedCandidate(state,action); 
    case actionTypes.SET_JOBLIST:
      return setJobList(state,action); 
    case actionTypes.SET_JOBTITLE:
      return setJobTitle(state,action);   
    case actionTypes.SET_CURRENT_ROLE:
      return updateCurrentRole(state,action);  
    case actionTypes.COGNITO_LOGOUT:
      return clearReduxState(state,action);
    case actionTypes.CLEAR_TALENT_POOL:
      return clearTalentPool(state,action); 
    case actionTypes.IMPORT_CANDIDATE_RECRUITER:
      return importCandidate(state,action);
    case actionTypes.REMOVE_CANDIDATE_RECRUITER:
      return removeCandidate(state,action); 
    case actionTypes.SET_PERMITTED_CONTACT:
      return setPermittedcontactdata(state,action); 
    case actionTypes.SET_CANDIDATE_EDIT_STATUS:
      return updateCandidateEditStatus(state,action);  
    case actionTypes.UPDATE_CANDIDATE_PUBLISHED:
      return updateCandidatePublished(state,action);      
      case actionTypes.SET_CANDIDATE_CARD_IMAGE:
      return setCandidateCardProfileImage(state,action)  
    case actionTypes.SET_CANDIDATE_PROFILE_EDIT:
    return updateCandidateProfileEdit(state,action) 
    case actionTypes.SET_PROGRESS_NOTIFICATION:
      return setProgressNotification(state,action)
    default:
      return state;
  }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/store/reducers/talentPool.js